import { useTranslation } from 'react-i18next';
import { useMeQuery } from '@platform/state/api';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { AssignedCard } from '../shell/AssignedCard';
import { PinnedModulesGrid } from '../shell/PinnedModulesGrid';
import { ActivityCard } from '../shell/ActivityCard';
import { useWorkspaceMeta } from '../shell/useWorkspaceMeta';
import '../shell/home.css';

/** Привітання за часом доби (прототип v4: до 12 — ранок, до 18 — день, далі — вечір). */
const greetingKey = (hour: number) => (hour < 12 ? 'homePage.greetMorning' : hour < 18 ? 'homePage.greetAfternoon' : 'homePage.greetEvening');

/**
 * Головна робочого простору (прототип v4): «Доброго ранку, Оксано» з назвою простору, дві картки — «Призначені вам» і «Нещодавня активність»
 * (дві колонки від 2 × 380px, інакше одна), нижче — «Закріплені модулі» з переходом до «Усіх модулів».
 */
export function HomePage() {
  const { t } = useTranslation();
  const { ws } = useWorkspaceParams();
  const { data: me } = useMeQuery();
  const { workspace } = useWorkspaceMeta(ws);
  const name = me?.displayName.split(' ')[0] ?? '';
  return (
    <div className="hp-page">
      <div className="hp-head">
        <h1>{t(greetingKey(new Date().getHours()), { name })}</h1>
        <div className="muted">{workspace?.name}</div>
      </div>
      <div className="hp-cards">
        <AssignedCard ws={ws} />
        <ActivityCard ws={ws} />
      </div>
      <PinnedModulesGrid ws={ws} />
    </div>
  );
}
